const defaultErrorMessage = "Unbekannter Fehler";

export const getErrorMessage = (error: unknown, fallback = defaultErrorMessage): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return fallback;
};

export const normalizeError = (error: unknown, fallbackMessage = defaultErrorMessage): Error => {
  if (error instanceof Error) {
    return error;
  }

  return new Error(getErrorMessage(error, fallbackMessage));
};
